// The cookie page, as data (see privacy.da.js). Keep the table in step with what the app really stores in the browser.
const cookies = {
  slug: 'cookies',
  kicker: 'Juridisk',
  title: 'Cookies',
  lead: 'Det, vi gemmer i din browser, er det, der skal til for at du kan logge ind, og for at tjenesten husker dine valg.',
  updated: 'Sidst opdateret 17. oktober 2026',
  scope: 'Gælder for nordcomply.dk og NordComply-portalen',
  summaryTitle: 'I korte træk',
  summary: [
    'Ingen reklame og ingen sporingsværktøjer.',
    'Vi sender ikke dine besøg videre til analyse- eller reklameselskaber.',
    'Vi gemmer kun det nødvendige, så der er intet cookiebanner.',
  ],
  tocTitle: 'På denne side',
  sections: [
    {
      id: 'gemmer',
      title: 'Hvad vi gemmer, og hvorfor',
      blocks: [
        { p: 'Det, vi gemmer, ligger i din browsers lokale lager og i få cookies. Alt er nødvendigt for, at tjenesten virker, eller for at den husker dine egne valg.' },
        {
          table: {
            head: ['Navn', 'Hvad det er', 'Hvorfor', 'Hvor længe'],
            rows: [
              ['nordcomply_user', 'Dit navn, din e-mail og dit login til tjenesten', 'Holder dig logget ind', 'Til du logger ud'],
              ['msal.*', 'Microsofts login-oplysninger (bruges af Microsoft-login)', 'Så du kan logge ind med din Microsoft-konto', 'Til du logger ud, eller de udløber'],
              ['nordcomply-theme', 'Dit valg af lyst eller mørkt tema', 'Husker dit valg', 'Indtil du rydder din browser'],
              ['nc-*', 'Indstillinger for kolonner, bredder, Focus mode og udkast til rapporter', 'Husker, hvordan du har sat siderne op', 'Indtil du rydder din browser'],
              ['__cf_bm', 'En cookie fra Cloudflare, som kan blive sat', 'Beskytter mod automatiseret misbrug', 'Højst 30 minutter'],
            ],
          },
        },
      ],
    },
    {
      id: 'tid',
      title: 'Måling af aktiv tid',
      blocks: [
        { p: 'Vi måler, hvor længe du arbejder i tjenesten (se privatlivspolitikken). Målingen sker kun i din browsers hukommelse, mens siden er åben. Der gemmes ikke noget på din enhed til det.' },
      ],
    },
    {
      id: 'skrifttyper',
      title: 'Skrifttyper og eksterne tjenester',
      blocks: [
        { p: 'Skrifttyperne på siden leveres fra vores egen server. Dit besøg sendes ikke til Google eller andre skrifttypetjenester, og vi indlæser ingen reklame- eller analyseværktøjer.' },
      ],
    },
    {
      id: 'slet',
      title: 'Sådan sletter du dem',
      blocks: [
        { p: 'Du kan til enhver tid slette alt, vi har gemt, i din browsers indstillinger under "Ryd browserdata". Du bliver så logget ud, og dine valg nulstilles.' },
        { note: '**Spørgsmål?** Skriv til support@nordcomply.dk, eller læs privatlivspolitikken for mere om, hvordan vi behandler dine oplysninger.' },
      ],
    },
  ],
};

export default cookies;
